// The Dashboard — the KPI landing page that used to be "Overview" at
// /rc/overview. LOCKED from 2026-10-20 (Alex); UNLOCKED 2026-10-21 with
// Dashboard v2 (src/dashboard/ — My Day, Store, Executive, Reports).
//
// The lock mechanism stays: set DASHBOARD_LOCKED to true to close the page
// again (false = open). Everything that leads to the page
// reads this file: the /dashboard route (redirects while locked), the sidebar
// row (lock icon, not clickable), the phone More sheet, the command palette,
// and every page's back arrow (HOME_PATH).

export const DASHBOARD_PATH = "/dashboard";

export const DASHBOARD_LOCKED = false;

// Where anyone heading for the Dashboard lands while it is locked: the same
// page sign-in lands on (contexts/User.jsx login(), the "/" redirect in Routes).
export const DASHBOARD_FALLBACK = "/requests/orders";

// The app's home — the target of every "back to the start" arrow.
export const HOME_PATH = DASHBOARD_LOCKED ? DASHBOARD_FALLBACK : DASHBOARD_PATH;
